import 'css-chunksrc/client/pages/projectPage/synthesisPage/monitoringLoader/milestones/styles.scss';export default {
  "milestones": "_milestones_cv69i_1",
  "timeline": "_timeline_cv69i_8",
  "list": "_list_cv69i_21",
  "milestone": "_milestone_cv69i_1",
  "today": "_today_cv69i_40",
  "dates": "_dates_cv69i_46",
  "date": "_date_cv69i_46"
};